import React from "react";
// import { gql, useMutation } from "@apollo/client";

import ThreeDot from "../../../assets/icons/three_dots.svg";
import "./DropDown.scss";

// const ARCHIVE_DOCUMENT = gql`
//   mutation ArchiveDocument($documentId: UUID!) {
//     archiveDocument(documentId: $documentId) {
//       success
//       document {
//         id
//         title
//         isArchive
//         archivedBy {
//           profile {
//             image
//           }
//           id
//           firstName
//           lastName
//         }
//         archivedAt
//       }
//     }
//   }
// `;

// const RESTORE_DOCUMENT = gql`
//   mutation RestoreFolders($folders: [UUID]) {
//     restoreFolders(folders: $folders) {
//       success
//     }
//   }
// `;

const DropDown = (props) => {
  const { isDisable = false } = props;
  // const [archiveDocument, { mutationData, error }] = useMutation(
  //   ARCHIVE_DOCUMENT
  // );

  // const [restoreDocument, { restoreMutationData, restoreError }] = useMutation(
  //   RESTORE_DOCUMENT
  // );

  // async function ArchiveDocument(e) {
  //   e.preventDefault();
  //   const variables = {
  //     documentId: props.documentId,
  //   };
  //   const created = await archiveDocument({
  //     variables: variables,
  //   });
  // }

  // async function RestoreDocument(e) {
  //   e.preventDefault();
  //   const variables = {
  //     folders: [props.documentId],
  //   };
  //   await restoreDocument({
  //     variables: variables,
  //   });
  // }
  if (isDisable) {
    return (
      <div className="dropdown custom-dropdown">
        <img
          className="dropdown-toggle"
          src={ThreeDot}
          alt="Three dots"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={(e) => {
            e.stopPropagation();
          }}
          style={{ opacity: 0.5, cursor: "not-allowed" }}
        />
      </div>
    );
  }
  return (
    <div className="dropdown custom-dropdown">
      <img
        className="dropdown-toggle"
        src={ThreeDot}
        alt="Three dots"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={(e) => {
          e.stopPropagation();
        }}
      />

      {props.isArchivedDropdown ? (
        <div
          className="dropdown-menu dropdown-menu-right custom-dropdown-items p-0"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            href="#/"
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={(e) => {
              e.preventDefault();
              props.restoreHandler();
            }}
          >
            Restore
          </a>
          <a
            href="#/"
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={props.deleteHandler}
          >
            Delete
          </a>
        </div>
      ) : props.isDocumentTemplate ? (
        <div
          className="dropdown-menu dropdown-menu-right custom-dropdown-items p-0"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            className="dropdown-item pl-5 pt-2 pb-2"
            href="#/"
            onClick={props.templateEditHandler}
          >
            Edit
          </a>

          <a
            className="dropdown-item pl-5 pt-2 pb-2"
            href="#/"
            onClick={(e) => {
              e.stopPropagation();
              props.statusHandler();
            }}
          >
            {props.documentType}
          </a>

          <a
            className="dropdown-item pl-5 pt-2 pb-2"
            href="#/"
            onClick={(e) => {
              e.stopPropagation();
              props.templateDeleteOpenHandler();
            }}
          >
            Delete
          </a>
        </div>
      ) : props.isTagManagement ? (
        <div
          className="dropdown-menu dropdown-menu-right custom-dropdown-items p-0"
          aria-labelledby="dropdownMenuButton"
        >
          <div
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={() => props.handleEdit(props.tag)}
          >
            Edit
          </div>

          <div
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={() => props.handleActivateDeactivate(props.tag)}
          >
            {props.tag.isActive ? "Deactivate" : "Activate"}
          </div>

          <div
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={() => props.handleDelete(props.tag)}
          >
            Delete
          </div>
        </div>
      ) : (
        <div
          className="dropdown-menu dropdown-menu-right custom-dropdown-items p-0"
          aria-labelledby="dropdownMenuButton"
        >
          <div
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={props.handleEdit}
          >
            Edit
          </div>
          {props.isDocumentView &&
          props.contentAccess &&
          props.contentAccess.role === "Owner" ? (
            <div
              className="dropdown-item pl-5 pt-2 pb-2"
              onClick={props.setMoveFileModalVisibility}
            >
              Move File
            </div>
          ) : null}
          <div
            className="dropdown-item pl-5 pt-2 pb-2"
            onClick={props.handleShare}
          >
            Share
          </div>
          {props.contentAccess && props.contentAccess.role === "Owner" ? (
            <div
              className="dropdown-item pl-5 pt-2 pb-2"
              onClick={props.handleArchive}
            >
              Archive
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default DropDown;
